import React from 'react';
import styles from './Landing.scss';

const PersonalData = () => (
  <div className={styles.Landing}>
    <h1>Согласие пользователя сайта на обработку персональных данных </h1>
    <p>
      Настоящим в соответствии с Федеральным законом № 152-ФЗ «О персональных данных» от 27.07.2006,
      Я, субъект персональных данных, именуемый в дальнейшем «Пользователь», во время использования
      мною веб-сайта: app.nedvex.ru (далее - Сайт, Сервис), свободно, своей волей и в своем интересе
      выражаю полное, безоговорочное и однозначное согласие на обработку моих персональных данных
      (далее - Согласие) на следующих условиях:
    </p>
    <p>
      Оставляя на Сайте любые из своих данных (которые отнесены к категории персональных в
      соответствии с ФЗ «О персональных данных» от 27.07.2006 №152-ФЗ), путем заполнения полей любых
      форм на Сайте, пользователь Сайта автоматически присоединяется к настоящему Соглашению,
      приобретает статус пользователя Сайта и соглашается со всеми без исключения его условиями.
    </p>
    <p>
      Настоящее согласие выдано ООО «Недвекс» (ОГРН 1162366056830, ИНН 2318043183),
      зарегистрированному по адресу: 354207, Краснодарский край, город Сочи, Лазаревский район,
      улица Летняя, строение 15/2 (далее - Оператор),
    </p>
    <p>
      Согласие дается на обработку персональных данных с использованием средств автоматизации и без
      использования таких средств, предоставляемых нижеуказанных персональных данных, включая
      использование интернет-сервисом Яндекс Метрика, в соответствии со следующем перечнем:
    </p>
    <ul>
      <li>IP адрес;</li>
      <li>информация из cookies;</li>
      <li>информация о браузере;</li>
      <li>время доступа;</li>
      <li>реферер (адрес предыдущей страницы).</li>
    </ul>
    <p>Также при подаче обращения посредством формы обратной связи:</p>
    <ul>
      <li>E-mail;</li>
      <li>Фамилия Имя Отчество;</li>
      <li>Должность/ роль в проекте;</li>
      <li>Контакты в мессенджерах;</li>
      <li>Номер телефона.</li>
    </ul>
    <p>Согласие выдано на обработку персональных данных в целях:</p>
    <ul>
      <li>продвижение товаров и услуг Оператора на рынке (измерения посещаемости Сайта);</li>
      <li>
        заключение и исполнение гражданско-правовых договоров (выбор субъектом персональных данных
        услуги, оформление записи на прием, направление информационных сообщений по услуге и записи
        на прием).
      </li>
    </ul>
    <p>
      Настоящее согласие включает в себя согласие на использование на Сайте Оператора программных
      средств интернет-статистики (в том числе файлов «cookie» - в случае, если это разрешено в
      настройках браузера Пользователя), позволяющих собирать и обрабатывать обезличенные данные о
      посетителях сайта, просматриваемых страницах, видах и версиях браузера и операционной системы,
      географии посетителей сайта. Указанные данные обрабатываются в целях продвижения товаров и
      услуг Оператора (повышения качества сайта).
    </p>
    <p>Пользователь Сайта:</p>
    <ul>
      <li>
        Подтверждает, что все указанные им в формах регистрации на Сайте данные принадлежат лично
        ему, соответствуют действительности, не искажены.
      </li>
      <li>
        Подтверждает и признает, что им внимательно в полном объеме прочитано настоящее Соглашение и
        условия обработки его персональных данных. Текст Соглашения и условия обработки персональных
        данных ему понятны и он с ними согласен;
      </li>
      <li>
        Дает согласие на обработку Оператором предоставляемых в составе информации персональных
        данных в целях заключения между ним и Оператором настоящего Соглашения, а также его
        последующего исполнения;
      </li>
      <li>
        Выражает согласие с условиями обработки персональных данных без оговорок и ограничений;
      </li>
      <li>
        В соответствии с ФЗ «О персональных данных» от 27.07.2006 №152-ФЗ свободно, своей волей и в
        своем интересе выражает согласие на сбор, анализ, обработку, хранение и использование своих
        персональных данных (ФИО, дата рождения, паспортные данные, места пребывания, адрес
        проживания, мобильный телефон, домашний телефон, электронный адрес (E-mail), реквизиты
        банковских карт, прочие данные).
      </li>
    </ul>
    <p>
      Пользователь Сайта предоставляет Оператору право осуществлять следующие действия (операции) с
      персональными данными:
    </p>
    <ul>
      <li>сбор и накопление;</li>
      <li>
        хранение в течение установленных нормативными документами сроков хранения отчетности, но не
        менее пяти лет, с момента даты прекращения пользования услуг Пользователем Сайта;
      </li>
      <li>уточнение (обновление, изменение);</li>
      <li>использование;</li>
      <li>уничтожение;</li>
      <li>обезличивание;</li>
      <li>
        передача по требованию суда, в том числе, третьим лицам, с соблюдением мер, обеспечивающих
        защиту персональных данных от несанкционированного доступа.
      </li>
    </ul>
    <p>
      Пользователя Сайта проинформирован о возможности отзыва согласия на основании положений
      Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» путем направления
      письменного обращения в свободной форме заказным письмом с уведомлением о вручении по
      юридическому адресу адрес Оператора.
    </p>
    <p>
      Настоящее согласие на обработку персональных данных действует с момента его представления
      Оператору и до достижения целей обработки на основании документов Оператора, регламентирующих
      вопросы обработки персональных данных. При достижении целей обработки Персональных данных, а
      также в случае отзыва Пользователем согласия на обработку персональных данных, Персональные
      данные подлежат уничтожению в соответствии с требованиями организационно-распорядительной
      документации Оператора.
    </p>
    <p>
      Согласие Пользователя Сайта на обработку персональных данных является конкретным,
      информированным и сознательным.
    </p>
    <p>Настоящее согласие Пользователя Сайта признается исполненным в простой письменной форме.</p>
    <p>
      Настоящим, Пользователь подтверждает, что ознакомился с положениями Федерального закона от
      27.07.2006 № 152-ФЗ «О персональных данных»,{' '}
      <a href="http://app.nedvex.ru/policy">
        «Политикой конфиденциальности персональных данных, обрабатываемых посредством сайта
        app.nedvex.ru»
      </a>
      .
    </p>
    <p>
      Согласие на обработку персональных данных подтверждается Пользователя Сайта путем заполнения
      полей любых форм на Сайте, проставления знака согласия в форме и нажатия кнопки «Отправить».
    </p>
  </div>
);

export default PersonalData;



// WEBPACK FOOTER //
// ./src/containers/Landing/PersonalData.jsx